import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const turkishCharacterRegex = (keyword) => {
  return keyword
    .replace(/İ/g, "I")
    .replace(/Ş/g, "S")
    .replace(/Ç/g, "C")
    .replace(/Ğ/g, "G")
    .replace(/Ö/g, "O")
    .replace(/Ü/g, "U");
};

export default function SelectBox({
  field,
  form: { touched, errors, setFieldValue },
  ...props
}) {
  const { t } = useTranslation();

  useEffect(() => {
    if (props.resetValue) {
      setFieldValue(field.name, null);
    }
  }, [props.resetValue]);

  return (
    <div className={"form-group col-md-" + (props.colNumber || 4)}>
      <label className="text-black font-w600">
        {props.label}
        {props.required ? "*" : ""}
        {props.buttonLabel}
      </label>
      <Select
        {...field}
        {...props}
        menuPlacement={props.menuPlacement || 'auto'}
        options={props.options || []}
        name={field.name}
        value={          
          props.options && field?.value
            ? props.options.length && props.options.find((option) => option.value === field?.value)
            : ""
        }
        onChange={(option) => {          
          if (option) {
            setFieldValue(field.name, option.value);
            if (props.onChangeFunc) {
              props.onChangeFunc(option.value);
            }
          } else {
            setFieldValue(field.name, "");
            if (props.onChangeFunc) {
              props.onChangeFunc("");
            }
          }
        }}
        filterOption={(candidate, input) => {
          return (
            candidate.data.__isNew__ ||
            turkishCharacterRegex(
              candidate.label.toLocaleUpperCase("tr-TR")
            ).includes(turkishCharacterRegex(input.toLocaleUpperCase("tr-TR")))
          );
        }}
        onBlur={field.onBlur}
        isClearable={!props.required}
        menuPortalTarget={document.body}
        styles={{
          minHeight: "45px",
          lineHeight: "50px",
          color: "#7e7e7e",
          paddingLeft: " 15px",
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        maxMenuHeight={250}
        placeholder={<span>{props.placeholder || t("formFields.selectPlaceHolder")}</span>}
      />
      {errors[field.name] && (
        <span className="text-danger">
          <small>*{errors[field.name]}</small>
        </span>
      )}
    </div>
  );
}
